// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PFileAddOutlinedSvg from "@fishx/icons-svg/es/asn/PFileAddOutlined";
import FishxIcon from '../components/FishxIcon';

var PFileAddOutlined = function PFileAddOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PFileAddOutlinedSvg
  }));
};

PFileAddOutlined.displayName = 'PFileAddOutlined';
export default React.forwardRef(PFileAddOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PFileAddOutlined.js
// module id = 3375
// module chunks = 0